import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  Index,
} from 'typeorm';

@Entity('tab_question')
export class TabQuestion {
  @PrimaryGeneratedColumn({ type: 'bigint' })
  name: number;

  @Column({ type: 'datetime', precision: 6, nullable: true })
  @Index()
  modified?: Date;

  @Column({ type: 'datetime', precision: 6, nullable: true })
  creation?: Date;

  @Column({ type: 'varchar', length: 140, nullable: true })
  modified_by?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  owner?: string;

  @Column({ type: 'int', width: 1, default: 0 })
  docstatus: number;

  @Column({ type: 'int', width: 8, default: 0 })
  idx: number;

  @Column({ type: 'varchar', length: 140, nullable: true })
  class?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  subject?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  chapter?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  topic?: string;

  @Column({ type: 'longtext', nullable: true })
  question?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  marks?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  language?: string;

  @Column({ type: 'text', nullable: true })
  _user_tags?: string;

  @Column({ type: 'text', nullable: true })
  _comments?: string;

  @Column({ type: 'text', nullable: true })
  _assign?: string;

  @Column({ type: 'text', nullable: true })
  _liked_by?: string;

  @Column({ type: 'int', default: 0 })
  usage_count: number;

  @Column({ type: 'longtext', nullable: true })
  question_te?: string;

  @Column({ type: 'longtext', nullable: true })
  question_ur?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  difficulty?: string;

  @Column({ type: 'varchar', length: 140, nullable: true })
  cognitive?: string;

  @Column({ type: 'int', default: 0 })
  q_no: number;

  @Column({ type: 'varchar', length: 140, nullable: true })
  old_id?: string;

  @Column({ type: 'varchar', length: 140, nullable: true, unique: true })
  id?: string;

  @Column({ type: 'varchar', length: 140, default: 'Active' })
  status: string;

  @Column({ type: 'longtext', nullable: true })
  answer_en?: string;

  @Column({ type: 'longtext', nullable: true })
  answer_te?: string;

  @Column({ type: 'longtext', nullable: true })
  answer_ur?: string;
}
